import React from "react";
import "./Card.css";

export default function PlaylistCard({ image }) {
  return (
    <div className="playlist-card-wrapper">
      <div className="image-contain">
        <img src={image} alt="no" />
      </div>
      <div className="info">
        <div className="title">March 2021 Hot </div>
        <div className="playlist-bids">By 8 Tracks</div>
      </div>
    </div>
  );
}
